export default __webpack_public_path__ + "alberta-shoppingcart-small-icon-button.7ee6ba2ba0bbcee18394.svg";